export enum ProductCategory {
  GB_PRIVATE_HIRE = 'GB.PRIVATE_HIRE',
  GB_VAN = 'GB.VAN',
  GB_VAN_OWN_GOODS = 'GB.VAN_OWN_GOODS',
}
